import * as locationTypes from 'state-management/constants/location';

export default function setQueryParams(query) {
    return {
        type: locationTypes.SET_QUERY_PARAMS,
        query,
    };
}
